import {Component, Input,} from '@angular/core';
import {OneToManyComponent} from "../../one-to-many.component";
import {Arquivo} from "../../../../domain/Arquivo";
import {Camera, CameraResultType, CameraSource, Photo} from '@capacitor/camera';
import {Directory, Filesystem} from "@capacitor/filesystem";
import {EnumSincronizacao} from "../../../../domain/EnumSincronizacao";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-arquivo',
  templateUrl: './edit-arquivo.component.html',
  styleUrls: ['./edit-arquivo.component.scss'],
})
export class EditArquivoComponent extends OneToManyComponent<Arquivo>{
  override newObject(): Arquivo {
    return new Arquivo();
  }

  @Input()
  override set entidades(valor: Arquivo[]){
    this._entidades = valor
    this.loadSave().then()
  }

  public async getFoto(origem: CameraSource) {
    // Take a photo,
    const capturedPhoto = await Camera.getPhoto({
      resultType: CameraResultType.DataUrl,
      source: origem,
      saveToGallery: true,
      quality: 100
    });
    this._entidades = this._entidades || []
    const savedImageFile = await this.savePicture(capturedPhoto);
    const arquivo = new Arquivo()
    arquivo.caminho = savedImageFile
    arquivo.situacao = EnumSincronizacao.ENVIAR
    arquivo.nome = savedImageFile

    // arquivo.url = capturedPhoto.webPath
    await this.calculaURL(arquivo)
    this._entidades.unshift(arquivo);
    console.log('entidades',this._entidades)
    // this.entidadesChange.emit(this.entidades)
  }

  private async savePicture(photo: Photo) {
    // const base64Data = await this.readAsBase64(photo);
    const fileName = Date.now() + '.jpeg';
    await Filesystem.writeFile({
      path: fileName,
      data: photo.dataUrl,
      directory: Directory.Data
    });
    return fileName
  }

  async loadSave(){
    // if(Capacitor.getPlatform() === 'web') {
      console.log('arquivos', this._entidades?.length)
      if (this._entidades) {
        for (let arquivo of this._entidades) {
         await this.calculaURL(arquivo)
        }
      }
    // }
  }

  async calculaURL(arquivo: Arquivo){
    if(arquivo.situacao == EnumSincronizacao.INCOMPLETO || arquivo.situacao == EnumSincronizacao.ENVIAR) {
      // Read each saved photo's data from the Filesystem
      const readFile = await Filesystem.readFile({
        path: arquivo.nome,
        directory: Directory.Data,
      });

      // Web platform only: Load the photo as base64 data
      arquivo.url = `data:image/jpeg;base64,${readFile.data}`;
    } else {
      arquivo.url = environment.url + "/api/storage/" + arquivo.caminho
    }
  }


  // private async readAsBase64(photo: Photo) {
  //   // Fetch the photo, read as a blob, then convert to base64 format
  //   const response = await fetch(photo.webPath!);
  //   const blob = await response.blob();
  //
  //   return await this.convertBlobToBase64(blob) as string;
  // }

  // private convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
  //   const reader = new FileReader();
  //   reader.onerror = reject;
  //   reader.onload = () => {
  //     resolve(reader.result);
  //   };
  //   reader.readAsDataURL(blob);
  // });
  protected readonly CameraSource = CameraSource;
}
